<template>
  <div>
    <v-app-bar
      app
      fixed
      class="site-header px-0"
      :class="$route.name === '/' || $route.name === 'beranda' ? 'header' : ''"
      :prominent="false"
      :hide-on-scroll="false"
      :extended="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'"
      extension-height="52"
      scroll-target="#scrolling-techniques-4"
      color="#ffffff"
      elevation="0"
      style="z-index: 3;"
      :height="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 112 : 72">

      <div class="d-flex flex-column" style="width: 100%; height: 100%;">
      <!-- Utility / identity strip (own row, full-bleed color, lives inside the same fixed bar) -->
      <div
        v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'"
        class="topbar d-flex align-center justify-space-between"
        :style="`background: ${set_color};`">
        <div class="d-flex align-center topbar-left">
          <span class="topbar-item">
            <v-icon size="14" color="#fff" class="mr-1">mdi-map-marker-outline</v-icon>
            Pemerintah Kabupaten Klaten
          </span>
          <span class="topbar-item">
            <v-icon size="14" color="#fff" class="mr-1">mdi-email-outline</v-icon>
            jdih@klaten.go.id
          </span>
        </div>

        <div class="d-flex align-center">
          <span class="topbar-tag">jdih.klaten.go.id</span>

          <v-menu transition="slide-x-transition" bottom right offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="topbar-lang d-flex align-center">
                <v-icon size="16" color="#fff" class="mr-1">mdi-translate</v-icon>
                {{ selected.title }}
                <v-icon size="16" color="#fff" class="ml-1">mdi-chevron-down</v-icon>
              </div>
            </template>
            <v-list class="py-2 nav-dropdown">
              <v-list-item
                v-for="country in countries"
                :key="country.title"
                @click="selected.language = country.title; doTranslation(country.code)" :title="country.title">
                <v-list-item-content>
                  <div class="d-flex align-center">
                    <div>
                      <v-img
                        :alt="country.altText ? country.altText : `${country.title} flag icon`"
                        :src="
                          country.code !== 'en|id'
                            ? `https://cdn.jsdelivr.net/gh/lewis-kori/vue-google-translate/src/assets/images/flags/__${country.title}.png`
                            : country.flagIconUrl"
                        class="flag">
                      </v-img>
                    </div>
                    <span class="ml-1">{{ country.title }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <v-container fluid class="px-4 px-lg-6 main-row">
        <div class="d-flex align-center fill-height justify-space-between" style="width: 100%;">

          <!-- Brand -->
          <nuxt-link
            to="/beranda"
            class="brand d-flex align-center text-decoration-none flex-shrink-0">
            <v-img
              contain
              width="44"
              height="44"
              alt="JDIH Kabupaten Klaten"
              :src="require('@/assets/logo/favicon.png')"
              class="brand-logo">
              <template v-slot:placeholder>
                <v-row class="fill-height" align="center" justify="center">
                  <v-progress-circular size="20" indeterminate :color="set_color" />
                </v-row>
              </template>
            </v-img>
            <div class="brand-text ml-3 d-none d-sm-flex flex-column">
              <span class="brand-title" :style="`color: ${set_color}`">JDIH KABUPATEN KLATEN</span>
              <span class="brand-subtitle">Jaringan Dokumentasi &amp; Informasi Hukum</span>
            </div>
          </nuxt-link>

          <!-- Quick search (desktop) -->
          <div
            v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'"
            class="quick-search d-flex align-center">
            <v-icon size="18" class="ml-4 mr-2" color="#9aa1ab">mdi-magnify</v-icon>
            <input
              v-model="search"
              type="text"
              placeholder="Cari peraturan…"
              class="quick-search-input"
              @keyup.enter="changeQuery()">
            <v-btn
              icon
              small
              class="quick-search-btn"
              :style="`background: ${set_color};`"
              @click="changeQuery()">
              <v-icon size="18" color="#fff">mdi-arrow-right</v-icon>
            </v-btn>
          </div>

          <!-- Mobile hamburger -->
          <v-btn
            v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'"
            icon
            @click="drawerMobile = true">
            <v-icon size="28">mdi-menu</v-icon>
          </v-btn>
        </div>
      </v-container>
      </div>

      <!-- Full-width nav row -->
      <template v-slot:extension v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
        <v-container fluid class="px-4 px-lg-6 fill-height py-0">
          <div ref="navRow" class="nav-row fill-height">
            <nav ref="navDesktop" class="nav-desktop d-flex align-center fill-height justify-center">
              <div
                  v-for="(item, index) in visibleMenu"
                  :key="index">

                  <div v-if="item.sub === undefined">
                    <v-tooltip v-if="item.link.split('/')[1] === 'beranda'" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :to="item.link"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="nav-link nav-link-icon mx-1"
                          :class="$route.path === '/' || $route.path.split('/')[1] === 'beranda' ? 'nav-link-active' : ''"
                          :style="$route.path === '/' || $route.path.split('/')[1] === 'beranda' ? `color: ${set_color}` : ''">
                          <v-icon size="22">mdi-home-variant</v-icon>
                        </v-btn>
                      </template>
                      <span>Beranda</span>
                    </v-tooltip>
                    <v-btn
                      v-else
                      :to="item.link"
                      text
                      class="nav-link body-2 text-capitalize px-2"
                      :class="$route.path === '/' ? item.link.split('/')[1] === 'beranda' ? 'nav-link-active' : '' : $route.path.split('/')[1] === item.link.split('/')[1] ? 'nav-link-active' : ''"
                      :style="$route.path === '/' ? item.link.split('/')[1] === 'beranda' ?  `color: ${set_color}` : '' : $route.path.split('/')[1] === item.link.split('/')[1] ? `color: ${set_color}` : ''">
                      {{ item.title }}
                    </v-btn>
                  </div>

                  <div v-if="item.sub !== undefined">
                    <v-menu v-if="item.title === 'Tentang Kami'" offset-y :close-on-content-click="true" v-model="subMenu">

                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="voiceHover(item.title)"
                          class="nav-link body-2 text-capitalize px-2"
                          :class="[$route.path.split('/')[1] === item.link.split('/')[1] ? 'nav-link-active' : '', subMenu ? 'nav-link-open' : '']"
                          :style="$route.path.split('/')[1] === item.link.split('/')[1] ? `color: ${set_color}` : ``">
                          {{ item.title }}
                          <v-icon class="nav-caret" size="20">mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-card min-width="280" class="nav-dropdown">
                        <v-list class="py-2">
                          <v-list-item
                            v-for="(i, m) in item.sub"
                            :key="m"
                          >
                            <v-list-item-title>
                              <v-hover v-slot="{ hover }">
                                <div :class="hover ? 'font-weight-bold' : ''" class="cursor-pointer" :style="hover ? `color: ${set_color}` : ''">
                                  <v-btn
                                    style="color: rgba(0, 0, 0, 0.87)"
                                    :to="i.link"
                                    text
                                    @mouseover="voiceHover(i.title)"
                                    block
                                    class="justify-start text-capitalize dropdown-item"
                                    :class="hover ? 'font-weight-bold' : $route.fullPath === i.link ? 'font-weight-bold' : ''" :style="hover ? `color: ${set_color}` : $route.fullPath === i.link ? `color: ${set_color}` : ''" >
                                    {{ i.title }}
                                  </v-btn>
                                </div>
                              </v-hover>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>

                  <v-menu v-if="item.isDocType" offset-y :close-on-content-click="true">
                   <template v-slot:activator="{ on, attrs }">
                     <v-btn
                       text
                       v-bind="attrs"
                       v-on="on"
                       @mouseover="voiceHover(item.title)"
                       class="nav-link body-2 text-capitalize px-2"
                       :class="$route.path.split('/')[1] === item.link.split('/')[1] ? 'nav-link-active' : ''"
                       :style="$route.path.split('/')[1] === item.link.split('/')[1] ? `color: ${set_color}` : ``">
                       {{ item.title }}
                       <v-icon class="nav-caret" size="20">mdi-chevron-down</v-icon>
                     </v-btn>
                   </template>
                   <v-card min-width="280" class="nav-dropdown">
                     <v-list class="py-2">
                       <v-list-item
                         v-for="(i, m) in item.sub"
                         :key="m"
                       >
                         <v-list-item-title>
                           <v-hover v-slot="{ hover }">
                             <div :class="hover ? 'font-weight-bold' : ''" class="cursor-pointer" :style="hover ? `color: ${set_color}` : ''">
                               <v-btn
                                style="color: rgba(0, 0, 0, 0.87)"
                                :to="i.link"
                                text
                                @mouseover="voiceHover(i.title)"
                                block
                                class="justify-start text-capitalize dropdown-item"
                                :class="hover ? 'font-weight-bold' : $route.fullPath === i.link ? 'font-weight-bold' : ''" :style="hover ? `color: ${set_color}` : $route.fullPath === i.link ? `color: ${set_color}` : ''" >
                                {{ i.title }}
                              </v-btn>
                             </div>
                           </v-hover>
                         </v-list-item-title>
                       </v-list-item>
                     </v-list>
                   </v-card>
                 </v-menu>

                 <v-menu v-if="item.title === 'Informasi'" offset-y :close-on-content-click="true" v-model="subMenu2">

                   <template v-slot:activator="{ on, attrs }">
                     <v-btn
                       text
                       v-bind="attrs"
                       v-on="on"
                       @mouseover="voiceHover(item.title)"
                       class="nav-link body-2 text-capitalize px-2"
                       :class="$route.path.split('/')[1] === item.link.split('/')[1] ? 'nav-link-active' : ''"
                       :style="$route.path.split('/')[1] === item.link.split('/')[1] ? `color: ${set_color}` : ``">
                       {{ item.title }}
                       <v-icon class="nav-caret" size="20">mdi-chevron-down</v-icon>
                     </v-btn>
                   </template>
                   <v-card min-width="280" class="nav-dropdown">
                     <v-list class="py-2">
                       <v-list-item
                         v-for="(i, m) in item.sub"
                         :key="m"
                       >
                         <v-list-item-title>
                           <v-hover v-slot="{ hover }">
                             <div :class="hover ? 'font-weight-bold' : ''" class="cursor-pointer" :style="hover ? `color: ${set_color}` : ''">
                              <v-btn
                                style="color: rgba(0, 0, 0, 0.87)"
                                :to="i.link"
                                text
                                @mouseover="voiceHover(i.title)"
                                block
                                class="justify-start text-capitalize dropdown-item"
                                :class="hover ? 'font-weight-bold' : $route.fullPath === i.link ? 'font-weight-bold' : ''" :style="hover ? `color: ${set_color}` : $route.fullPath === i.link ? `color: ${set_color}` : ''" >
                                {{ i.title }}
                              </v-btn>
                             </div>
                           </v-hover>
                         </v-list-item-title>
                       </v-list-item>
                     </v-list>
                   </v-card>
                 </v-menu>
                  </div>
              </div>

              <!-- Overflow items that don't fit (rare now — this row has the full page width) -->
              <v-menu v-if="moreMenu.length" offset-y :close-on-content-click="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    v-bind="attrs"
                    v-on="on"
                    class="nav-link body-2 text-capitalize px-2">
                    Lainnya
                    <v-icon class="nav-caret" size="20">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-card min-width="260" class="nav-dropdown">
                  <v-list class="py-2" dense>
                    <template v-for="(item, index) in moreMenu">
                      <v-subheader v-if="item.sub !== undefined" :key="`h-${index}`" class="more-subheader">
                        {{ item.title }}
                      </v-subheader>
                      <v-list-item
                        v-if="item.sub !== undefined"
                        v-for="(i, m) in item.sub"
                        :key="`hi-${index}-${m}`"
                        :to="i.link"
                        class="dropdown-item mx-2">
                        <v-list-item-title class="text-capitalize">{{ i.title }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="item.sub === undefined"
                        :key="`li-${index}`"
                        :to="item.link"
                        class="dropdown-item mx-2">
                        <v-list-item-title class="text-capitalize">{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card>
              </v-menu>
            </nav>
          </div>
        </v-container>
      </template>
    </v-app-bar>

    <!-- Mobile drawer -->
    <v-navigation-drawer
      v-model="drawerMobile"
      right
      temporary
      app
      width="300"
      class="mobile-drawer">
      <div class="d-flex align-center justify-space-between px-4 py-4">
        <div class="d-flex align-center">
          <v-img contain width="34" height="34" :src="require('@/assets/logo/favicon.png')" />
          <span class="ml-2 brand-title" :style="`color: ${set_color}; font-size: 15px;`">JDIH KLATEN</span>
        </div>
        <v-btn icon @click="drawerMobile = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider />
      <v-list nav dense class="py-2">
        <template v-for="(item, index) in menu">
          <v-list-item
            v-if="item.sub === undefined"
            :key="`m-${index}`"
            :to="item.link"
            @click="drawerMobile = false"
            class="mobile-nav-item">
            <v-list-item-title class="text-capitalize">{{ item.title }}</v-list-item-title>
          </v-list-item>

          <v-list-group
            v-else
            :key="`g-${index}`"
            no-action>
            <template v-slot:activator>
              <v-list-item-title class="text-capitalize">{{ item.title }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(i, m) in item.sub"
              :key="`s-${index}-${m}`"
              :to="i.link"
              @click="drawerMobile = false"
              class="mobile-nav-subitem">
              <v-list-item-title class="text-capitalize">{{ i.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <v-divider />
      <div class="px-4 py-3">
        <div class="mobile-lang-label mb-2">Bahasa</div>
        <v-select
          :items="countries"
          item-text="title"
          item-value="code"
          v-model="selected.language"
          outlined
          dense
          hide-details
          @change="doTranslation(countries.find(c => c.title === selected.language).code)">
        </v-select>
      </div>
    </v-navigation-drawer>

  </div>
</template>

<script>
  const Cookie = process.client ? require('js-cookie') : undefined
  export default {
    middleware: 'notAuthenticated',
    data () {
      return {
        clipped: false,
        drawer: true,
        drawerMobile: false,
        overflowCount: 0,
        subMenu: false,
        subMenu2: false,
        subMenu3: false,
        dialog: {
          auth: false,
          otp: false,
          info: false
        },
        countries: [
          {
            code: "en|id",
            title: "Indonesia",
            flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/id.svg"
          },
          {
            code: "en|en",
            title: "English",
          },
          {
            code: 'en|af',
            title: 'Afrikaans',
          },
          {
            code: 'en|ar',
            title: 'Arabic',
          },
          {
            code: 'en|ko',
            title: 'Korean',
          },
          {
            code: 'en|lt',
            title: 'Lithuanian',
          }
        ],
        selected: {
          auth: 'login',
          category: '',
          language: 'Indonesia',
          title: 'Indonesia',
        },
        search: '',
        category: [
          {
            name: 'Peraturan Daerah',
            data: "76"
          },
          {
            name: 'Keputusan Bupati',
            data: "30"
          },
          {
            name: 'Rancangan Peraturan Daerah',
            data: "21"
          },
          {
            name: 'Produk Hukum Desa',
            data: "21"
          },
          {
            name: 'Abstrak Peraturan Daerah',
            data: "12"
          },
          {
            name: 'MOU dan PKS',
            data: "5"
          },
          {
            name: 'Surat Edaran Bupati',
            data: "9"
          },
          {
            name: 'Propemperda',
            data: "2"
          },

          {
            name: 'Peraturan Bupati',
            data: "15"
          },
          {
            name: 'Instruksi Bupati',
            data: "20"
          },
          {
            name: 'Rancangan Peraturan Bupati',
            data: "33"
          },
          {
            name: 'Naskah Akademis',
            data: "21"
          },
          {
            name: 'Staatsblad',
            data: "5"
          },
          {
            name: 'Surat Edaran Sekda',
            data: "2"
          },
          {
            name: 'Peraturan Terjemahan Resmi',
            data: "76"
          },
        ],
        produkHukum: [
          {
            name: 'Peraturan Daerah',
            data: "76"
          },
          {
            name: 'Keputusan Bupati',
            data: "30"
          },
          {
            name: 'Rancangan Peraturan Daerah',
            data: "21"
          },
          {
            name: 'Abstrak Peraturan Daerah',
            data: "12"
          },

          {
            name: 'Peraturan Bupati',
            data: "15"
          },
          {
            name: 'Instruksi Bupati',
            data: "20"
          },
          {
            name: 'Rancangan Peraturan Bupati',
            data: "33"
          },
          {
            name: 'Produk Hukum Desa',
            data: "12"
          },
          {
            name: 'Staatsblad',
            data: "5"
          },
          {
            name: 'Peraturan Terjemahan Resmi',
            data: "76"
          },
        ],
        menu: [
          {
            title: 'Beranda',
            link: '/beranda'
          },
          {
            title: 'Tentang Kami',
            link: '/visi-misi',
            sub: [
              {
                title: 'Visi dan Misi',
                link: '/visi-misi'
              },
              {
                title: 'Tugas Pokok, Fungsi dan Program Kerja',
                link: '/tugas-pokok-fungsi-dan-program-kerja'
              },
              {
                title: 'Hubungi Kami',
                link: '/hubungi-kami'
              },
              {
                title: 'Anggota JDIH',
                link: '/anggota-jdih'
              },
              {
                title: 'SOP',
                link: '/SOP'
              },
              {
                title: 'Tim Pengelola',
                link: '/struktur-organisasi'
              }
            ]
          },
          // {
          //   title: 'PPID',
          //   link: '/PPID'
          // },
          // {
          //   title: 'Produk Hukum Desa',
          //   link: '/page?category=produk-hukum-desa'
          // },
          // Dokumen Hukum dihapus — isi kategori di-inject sebagai menu top-level via fetchCategory
          {
            title: 'Informasi',
            link: '/berita',
            sub: [
              {
                title: 'Berita',
                link: '/berita'
              },
              {
                title: 'Pengumuman',
                link: '/pengumuman'
              },
              {
                title: 'Video',
                link: '/video'
              },
              {
                title: 'Galeri',
                link: '/galeri'
              },
              {
                title: 'Statistik',
                link: '/statistik'
              }
            ]
          },
          {
            title: 'Pengaduan',
            link: '/pengaduan'
          },
          // {
          //   title: 'Download',
          //   link: '/pariwisata',
          //   sub: [
          //     {
          //       title: 'Dokumen',
          //       link: '/dokumen'
          //     },
          //     {
          //       title: 'Katalog Perda',
          //       link: '/katalog-perda'
          //     },
          //     {
          //       title: 'Katalog Perbup',
          //       link: '/katalog-perbup'
          //     }
          //   ]
          // },
          // {
          //   title: 'Koleksi Buku',
          //   link: '/buku'
          // },
        ]
      }
    },
    head () {
  return {
    script: [
      {
        src: '/bundle.js',
        type: 'text/javascript',
        defer: true,
        body: true
      },
      // {
      //   innerHTML:
      //     function googleTranslateElementInit() {
      //       new google.translate.TranslateElement(
      //         { pageLanguage: 'id', autoDisplay: false },
      //         'app'
      //       );
      //       // console.log(pageLanguage)
      //     }
      //   ,
      //   type: 'text/javascript',
      //   defer: true,
      //   body: true
      // }
    ]
  }
},
    watch: {
      '$route': function() {
        if (this.$route.path.split('/')[1] !== 'page') {
          this.search = ''
          this.selected.category = ''
        }
      },
      '$route.query.jenis': function(val) {
        for(let i = 0; i < this.category.length; i++){
          if (this.category[i].slug === val) {
            this.selected.category = this.category[i].slug
          } else {
            // status = false
          }
        }
      },
      '$route.query.search': function(val) {
        this.search = val
      },
      'menu.length': function() {
        this.$nextTick(() => this.recalcNav())
      },
      rps: function() {
        this.$nextTick(() => this.recalcNav())
      },
      // 'selected.language': function(val) {
      //   this.selected.title = this.countries.find(country => country.code === val).title
      //   // this.selected.title = val
      // },
    },
    components: {

    },

    computed: {
      hasClickListener() {
        return Object.keys(this.$listeners).includes('on-country-click');
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.member.auth.user
      },
      token () {
        return this.$store.state.member.auth.token
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      company () {
        return this.$store.state.header.config
      },
      visibleMenu () {
        const cut = this.menu.length - this.overflowCount
        return this.menu.slice(0, Math.max(cut, 0))
      },
      moreMenu () {
        const cut = this.menu.length - this.overflowCount
        return this.menu.slice(Math.max(cut, 0))
      },
      // role_admin () {
      //   if (this.$route.name === null) {
      //     this.$router.push('/404')
      //   } else {
      //     return this.$route.name.includes('admin')
      //   }
      // }
    },
    mounted () {
      if (!process.server) {
        const script = document.createElement("script");
        script.onload = this.onScriptLoaded;
        script.type = "text/javascript";
        script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        document.head.appendChild(script);
      }
      // console.log(window.doGTranslate())
      // console.log(this.googleTranslateElementInit())
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) {
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        }
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })

      storeScroll()

      this.$nextTick(() => this.recalcNav())
      if (typeof ResizeObserver !== 'undefined') {
        this._navResizeObserver = new ResizeObserver(debounce(() => this.recalcNav()))
        this.$nextTick(() => {
          if (this.$refs.navRow) this._navResizeObserver.observe(this.$refs.navRow)
        })
      } else {
        this._navResizeHandler = debounce(() => this.recalcNav())
        window.addEventListener('resize', this._navResizeHandler)
      }
      // extra safety retries in case breakpoint/layout settles a little later
      setTimeout(() => this.recalcNav(), 300)
      setTimeout(() => this.recalcNav(), 1000)

      // this.category = this.category.map(item => {
      //   const container = {};

      //   container.name = item.name;
      //   container.slug = (item.name.split(' ').join('-')).toLowerCase();
      //   container.data = item.data

      //   // this.category = container;
      //   return container
      // })

      this.fetchCategory()

      if(this.$route.query.search !== undefined){
        this.search = this.$route.query.search
      } else {
        this.search = ''
      }

      if(this.$route.path.split('/')[1] !== 'page'){
        this.selected.category = this.category[0].slug
      }

      // console.log(this.$route.path.split('/')[1])
    },
    beforeCreate() {

    },
    beforeDestroy () {
      if (!process.server) {
        if (this._navResizeObserver) this._navResizeObserver.disconnect()
        if (this._navResizeHandler) window.removeEventListener('resize', this._navResizeHandler)
      }
    },
    created() {

    },
    methods: {
      recalcNav () {
        if (process.server) return
        const row = this.$refs.navRow
        if (!row || !row.clientWidth) return // not rendered/visible yet — a later trigger (resize, breakpoint change, ResizeObserver) will retry
        this.overflowCount = 0
        this.$nextTick(() => this.shrinkStep())
      },
      shrinkStep () {
        const row = this.$refs.navRow
        const nav = this.$refs.navDesktop
        if (!row || !nav || !row.clientWidth) return
        if (nav.scrollWidth > row.clientWidth + 1 && this.overflowCount < this.menu.length - 1) {
          this.overflowCount++
          this.$nextTick(() => this.shrinkStep())
        }
      },
      googleTranslateElementInit() {
            new google.translate.TranslateElement(
              { pageLanguage: 'id', autoDisplay: false },
              'app'
            );
            // console.log(pageLanguage)
          // }

      },
      doTranslation (code) {
        this.googleTranslateElementInit()
        this.selected.title = ''

        this.selected.title = this.countries.find(country => country.code === code).title

        setTimeout(() => {
          if (typeof window !== 'undefined') {

            window.doGTranslate(code)

            if (this.hasClickListener) {
              this.$emit('on-country-click')
            }
          }
        }, 1000)
      },
      voiceHover (item) {
        responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
        responsiveVoice.speak(item, 'Indonesian Female');
      },
      async fetchCategory () {
        // this.process.load = true

        let params = {
          limit: 1000000
        }

        await this.$axios.$get(`${process.env.API}sites/doc/doc_type`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.category = [
              {
                name: "Semua Dokumen",
                slug: "semua-dokumen",
              }
            ]
            let category = []
            category = res.results.data.map(item => {
              const container = {};

              container.title = item.title;
              container.id = item.id;
              container.par_id = item.par_id;
              container.singkatan = item.singkatan
              container.link = `/page?jenis=${(item.title.split(' ').join('-')).toLowerCase()}`;
              return container
            })
            const docMenus = this.changeData(category).map(item => ({
              ...item,
              isDocType: true
            }))

            // hapus menu dokumen lama lalu sisipkan setelah Tentang Kami
            this.menu = this.menu.filter(m => !m.isDocType)
            const aboutIndex = this.menu.findIndex(m => m.title === 'Tentang Kami')
            const insertAt = aboutIndex === -1 ? 1 : aboutIndex + 1
            this.menu.splice(insertAt, 0, ...docMenus)

            let selecCategory = []
            selecCategory = res.results.data.map(item => {
              const container = {};
              container.par_id = item.par_id;
              container.name = item.title;
              container.slug = (item.title.split(' ').join('-')).toLowerCase();
              return container
            })

            // id: 11 Peraturan Desa, 31 Peraturan Kepala Desa, 30 Keputusan Kepala Desa
            const desaBottomIds = ['11', '31', '30']

            const children = selecCategory.filter(item => item.par_id !== '0')
            const bottomItems = desaBottomIds
              .map(id => children.find(item => String(item.id) === id))
              .filter(Boolean)
            const restItems = children.filter(item => !desaBottomIds.includes(String(item.id)))

            ;[...restItems, ...bottomItems].forEach(item => {
              this.category.push({
                name: item.name,
                slug: item.slug
              })
            })




            for(let i = 0; i < this.category.length; i++){
              if (this.category[i].slug === this.$route.query.jenis) {
                this.selected.category = this.category[i].slug
              } else {
                // status = false
              }
            }
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.par_id === parentKey
          })

          let result = []

          // id: 11 Peraturan Desa, 31 Peraturan Kepala Desa, 30 Keputusan Kepala Desa
          const desaBottomIds = ['11', '31', '30']

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.sub = kids
            }

            result.push(subItem)
          }

          const bottomItems = desaBottomIds
            .map(id => result.find(item => String(item.id) === id))
            .filter(Boolean)
          const restItems = result.filter(item => !desaBottomIds.includes(String(item.id)))
          result = [...restItems, ...bottomItems]

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },
      changeQuery() {
        this.$router.replace({'path': '/page', 'query': {'jenis': this.selected.category === '' ? 'semua-dokumen' : this.selected.category, 'search': this.search === null ? '' : this.search , 'category': this.$route.query.category === undefined ? '' : this.$route.query.category, 'tahun': this.$route.query.tahun === undefined ? '' : this.$route.query.tahun, 'nomor': this.$route.query.nomor === undefined ? '' : this.$route.query.nomor, 'title': this.$route.query.title === undefined ? '' : this.$route.query.title}})
      },
      toFilterCategory() {
        this.$router.replace({'path': '/page', 'query': {'jenis': this.selected.category === '' ? 'semua-dokumen' : this.selected.category, 'search': this.search === null ? '' : this.search , 'category': this.$route.query.category === undefined ? '' : this.$route.query.category, 'tahun': this.$route.query.tahun === undefined ? '' : this.$route.query.tahun, 'nomor': this.$route.query.nomor === undefined ? '' : this.$route.query.nomor, 'title': this.$route.query.title === undefined ? '' : this.$route.query.title}})
      },
      toList(link) {
        this.$router.push(`${link}`)
      },
      goTo (item) {
        if (item.type === 'logout') {
          Cookie.remove('token')
          Cookie.remove('user')
          Cookie.remove('fcm')
          Cookie.remove('notif')

          window.location = '/admin/auth/login'
        } else {
          this.$router.push('/admin/profil')
        }
      },
      goBack () {
        if (this.$route.name === 'reservasi-slug') {
          this.$router.push('/reservasi')
        } else if (this.$route.name === 'berita-slug') {
          this.$router.push('/berita')
        } else {
          this.$router.go(-1)
        }
      }
    }
  }
</script>

<style>
  /* ===== Utility / identity strip ===== */
  .topbar {
    flex: 0 0 36px;
    height: 36px;
    color: #fff;
    width: 100vw;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 24px;
  }
  .topbar-item {
    display: flex;
    align-items: center;
    font-size: 12px;
    opacity: .92;
    margin-right: 22px;
    white-space: nowrap;
  }
  .topbar-tag {
    font-size: 12px;
    opacity: .8;
    margin-right: 20px;
    letter-spacing: .2px;
  }
  .topbar-lang {
    font-size: 12.5px;
    cursor: pointer;
    padding: 4px 10px;
    border-radius: 50px;
    background: rgba(255,255,255,0.14);
    transition: background-color .15s ease;
  }
  .topbar-lang:hover {
    background: rgba(255,255,255,0.24);
  }

  /* ===== Header shell ===== */
  .site-header {
    border-bottom: 1px solid #eef0f2;
    box-shadow: 0 2px 10px rgba(16, 24, 40, 0.05) !important;
    transition: box-shadow .2s ease;
    overflow: visible;
  }
  .site-header .v-toolbar__content {
    padding: 0 !important;
    align-items: stretch !important;
  }
  .main-row {
    flex: 1 1 auto;
    min-height: 0;
  }
  .site-header .v-toolbar__extension {
    border-top: 1px solid #f0f1f3;
    background: #fafbfc;
    padding: 0 !important;
  }

  /* ===== Brand ===== */
  .brand-logo {
    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.06));
  }
  .brand-title {
    font-size: 16px;
    font-weight: 800;
    letter-spacing: .3px;
    line-height: 1.15;
  }
  .brand-subtitle {
    font-size: 11.5px;
    color: #6b7280;
    letter-spacing: .1px;
    line-height: 1.3;
  }

  /* ===== Quick search ===== */
  .quick-search {
    background: #f4f5f7;
    border: 1.5px solid transparent;
    border-radius: 50px;
    padding: 3px;
    min-width: 260px;
    transition: background-color .15s ease, border-color .15s ease;
  }
  .quick-search:hover {
    background: #ececee;
  }
  .quick-search:focus-within {
    background: #fff;
    border-color: #dfe1e5;
    box-shadow: 0 2px 10px rgba(16, 24, 40, 0.08);
  }
  .quick-search-input {
    flex: 1 1 auto;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    font-size: 13.5px;
    color: #374151;
    height: 34px;
  }
  .quick-search-input::placeholder {
    color: #9aa1ab;
  }
  .quick-search-btn {
    flex-shrink: 0;
    box-shadow: none !important;
  }
  .nav-link-icon {
    border-radius: 50% !important;
  }

  /* ===== Desktop nav ===== */
  .nav-row {
    min-width: 0;
    width: 100%;
    overflow: hidden;
  }
  .nav-desktop {
    gap: 2px;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  .more-subheader {
    font-size: 11px;
    font-weight: 700;
    color: #9aa1ab;
    text-transform: uppercase;
    letter-spacing: .4px;
    height: 28px;
  }
  .nav-link {
    border-radius: 8px !important;
    font-weight: 500;
    font-size: 13.5px !important;
    color: #374151 !important;
    letter-spacing: .1px;
    transition: background-color .15s ease, color .15s ease;
  }
  .nav-link:hover {
    background-color: rgba(0, 0, 0, 0.045) !important;
  }
  .nav-link-active {
    font-weight: 700;
  }
  .nav-link-active::before {
    opacity: 1;
  }
  .nav-caret {
    transition: transform .15s ease;
    opacity: .7;
  }
  .nav-link-open .nav-caret {
    transform: rotate(180deg);
  }

  .nav-dropdown {
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 12px 28px rgba(16, 24, 40, 0.14) !important;
  }
  .dropdown-item {
    border-radius: 8px !important;
  }
  .dropdown-item:hover {
    background-color: rgba(0, 0, 0, 0.045);
  }

  /* ===== Mobile drawer ===== */
  .mobile-drawer .brand-title {
    font-size: 15px;
  }
  .mobile-nav-item, .mobile-nav-subitem {
    border-radius: 8px;
  }
  .mobile-lang-label {
    font-size: 12px;
    font-weight: 700;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: .4px;
  }

  .header {
    /* background-color: transparent !important; */
  }
  .header-default {
    background-color: #a20000 !important;
  }
  .header-detail {
    background-color: transparent !important;
  }
  html:not([data-scroll="0"]) .header {
    /* background: url(@/assets/background/bg_basic.png); */
    /* background-color: #00000040 !important; */
    /* background-color: #a20000 !important; */
    background-repeat: no-repeat;
    background-position: 100%;
    background-size: cover;
    /* opacity: 80% !important; */
  }
  .header .menu {
    /* color: #FFFFFF !important; */
    background-color: transparent !important;
    /* opacity: 60%; */
  }

  .sub .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #ffffff !important;
  box-shadow: none !important;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  margin-bottom: 0px !important;
}

.theme--light.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot {
  background: #ffffff !important;
  /* border: 0.25px solid #4ab762; */
  border-width: 0.25px !important;
  border-radius: 6px;
  margin-bottom: 0px !important;
}

.theme--light.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot {
  background: #ffffff !important;
  /* border: 0.25px solid #4ab762; */
  border-width: 0.25px !important;
  border-radius: 6px;
  margin-bottom: 0px !important;
}

.error_input_border.v-input--is-focused > .v-input__control > .v-input__slot {
  background: #ffffff !important;
  border: 0.25px solid red !important;
  border-radius: 6px;
  margin-bottom: 0px !important;
}

.input-border-right-none.v-input--is-focused > .v-input__control > .v-input__slot {
  border-radius: 6px 0px 0px 6px !important;
}

.border-input-none.v-input--is-focused > .v-input__control > .v-input__slot {
  border-width: none !important;
}

.border-input-none > .v-input__control > .v-input__slot {
  border: none !important;
}

.border-input-none > .v-input__control > .v-input__slot > .v-input__prepend-inner{
  opacity: 0.6;
}

.border-input-none > .v-input__control > .v-input__slot > .v-text-field__slot{
  opacity: 0.6;
}

.input-border-right-none > .v-input__control > .v-input__slot {
  border-radius: 6px 0px 0px 6px !important;
}

.v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #FFFFFF !important;
  box-shadow: none !important;
  border-radius: 6px !important;
  margin-bottom: 0px !important;
}
</style>